import { render, staticRenderFns } from "./BlockPriceIndex.vue?vue&type=template&id=33185676&scoped=true"
import script from "./BlockPriceIndex.vue?vue&type=script&lang=js"
export * from "./BlockPriceIndex.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceIndex.vue?vue&type=style&index=0&id=33185676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33185676",
  null
  
)

export default component.exports